import React, { useState } from "react";
import AptCard from "./aptcard";
import CreateAppointment from "./createAppointment";
import VisitStatus from "./visitstatus";
import ProvidersStatus from "./providersstatus";
import Paymentsmodal from "../../landingscreen/modals/payments";
import Checkout from "./checkout";
import ProviderModal from "./Providermodal";
import RoomPopup from "./RoomChange";
import PurposeModal from "./PurposeModal";



const ModalSwitch = ({ isAptcard,screen,setScreen ,flow='',setIsAptcard,isfutureappointment,setIsFutureAppointment,fetchScheduleData ,selectedDate, selectedAppointment ,appointmentCardopen,setIsappointmentCardOpen, anchor, lockCancelled = false }) => {
 const [orderData,setOrderData]=useState(null)
const [navigateto,setNavigateTo]=useState(0)
  const [orderOptions, setOrderOptions] = useState([]);

  // The dashboard modal writes back through setFetchedData, which the scheduler
  // has no equivalent of: its rows come from scheduler/schedule_list, a
  // different shape and endpoint. Refetch the grid instead, so a payment taken
  // here is reflected the same way it would be on the dashboard.
  const refreshAfterPayment = () => {
    if (typeof fetchScheduleData === "function") fetchScheduleData();
  };

  /* The dashboard payment modal reads dashboard rows (id, startDate,
     linked_provider, purpose, start_time); a scheduler row carries AID,
     startdate, providername, type and starttime. Fill the dashboard names
     from the scheduler ones where they are missing, so its Change provider
     writes the visit's own date (not today) and Change purpose has the row
     id. A dashboard row already has them and passes through unchanged. */
  const paymentRow = selectedAppointment
    ? {
        ...selectedAppointment,
        id: selectedAppointment.id ?? selectedAppointment.AID,
        startDate: selectedAppointment.startDate ?? selectedAppointment.startdate,
        linked_provider: selectedAppointment.linked_provider ?? selectedAppointment.providername,
        purpose: selectedAppointment.purpose ?? selectedAppointment.type,
        start_time: selectedAppointment.start_time ?? selectedAppointment.starttime,
      }
    : null;

  const closeAllModals = () => {
    setIsAptcard(false);  // This will hide the AptCard screen
    setScreen(0);  // This resets the screen to 0
  };
  if (!isAptcard) return null;
  const renderScreen = () => {
    switch (screen) {
      case 0:
        return <AptCard isfutureappointment={isfutureappointment} setScreen={setScreen}  selectedAppointment={selectedAppointment}  setIsAptcard={setIsAptcard} anchor={anchor} lockCancelled={lockCancelled} />;
    case 1:
      setIsappointmentCardOpen(true);
      return <CreateAppointment 
      isfutureappointment={isfutureappointment} 
        selectedDate={selectedDate} 
      fetchScheduleData={fetchScheduleData}
         setIsAptcard={setIsAptcard} 
      setNavigateTo={setNavigateTo}
       setOrderData={setOrderData}
        orderData={orderData}
       setScreen={setScreen} 
       flow=''
       selectedAppointment={selectedAppointment} 
        appointmentCardopen={appointmentCardopen} />
      case 2:
        return <VisitStatus setIsAptcard={setIsAptcard} selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment} setScreen={setScreen} closeAllModals={closeAllModals} />
        case 3:
          // Same modal the dashboard uses. closePaymentModal is called with no
          // argument, so it must be closeAllModals, not setScreen - setScreen()
          // would fall through to the "Something Went wrong" default.
          return (
            <Paymentsmodal
              closePaymentModal={closeAllModals}
              data={paymentRow}
              alldata={paymentRow ? [paymentRow] : []}
              fetchedData={paymentRow ? [paymentRow] : []}
              setFetchedData={refreshAfterPayment}
              initialTab="pay"
            />
          )
          case 4:
            return <Checkout selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}   setIsAptcard={setIsAptcard}  navigateto={navigateto} setScreen={setScreen} orderData={orderData} closeAllModals={setScreen} selectedAppointment={selectedAppointment} />
            case 5:
              return <ProviderModal selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment} setScreen={setScreen} closeAllModals={closeAllModals} />
              case 6:
                return <RoomPopup selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment}  setScreen={setScreen}  closeAllModals={closeAllModals}/>
                case 7:
                  return <PurposeModal selectedDate={selectedDate} fetchScheduleData={fetchScheduleData}  selectedAppointment={selectedAppointment}  setScreen={setScreen} closeAllModals={closeAllModals} />
      default:
        return <div>Something Went wrong .</div>;
    }
  };

  return <>{renderScreen()}</>;
};

export default ModalSwitch;
